module.exports = {
    backend_port: 443,
    backend_domain: 'https://api.msqvr.com',
    backend_static: 'https://api.msqvr.com:443/static'
};
